'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _angularUiRouter = require('angular-ui-router');

var _angularUiRouter2 = _interopRequireDefault(_angularUiRouter);

var _atsi = require('./atsi.component');

var _atsi2 = _interopRequireDefault(_atsi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var atsiModule = _angular2.default.module('atsi', [_angularUiRouter2.default]).component('atsi', _atsi2.default);

exports.default = atsiModule;


// WEBPACK FOOTER //
// ./client/app/common/reports/atsi/atsi.js